import {
  Offer_Engagement_Type,
  EarningMechanism,
  Limit,
  Constraint,
  OfferFragment,
  MembershipOfferFragment,
  CampaignComponentFragment,
  EarningMechanismSpinWheelGame,
  EarningMechanismStoredValueDiscount,
} from '@occc/graphql';

// TODO: handle relation between type and subtype
// we should not be able to assign subtype that doesn't exist for specific type

// TODO: we will need something like PartialOfferFragment later for Campaign Components and Award Catalog tables
export type PartialOfferFragment = MembershipOfferFragment | CampaignComponentFragment;

export enum OfferType {
  Offer = 'offer',
  Promotion = 'promotion',
  Promocodes = 'promocodes',
  Reward = 'reward',
  ClubOrPunchcard = 'punchcard',
  Challenge = 'challenge',
  FuelRollback = 'fuelrollback',
  Sweepstakes = 'sweepstakes',
  Billboard = 'billboard',
  Award = 'award',
  LoyaltyEvent = 'loyaltyevent',
  StoredValue = 'storedvalue',
  FreeGame = 'freegame',
  VoucheredGame = 'voucheredgame',
  ExternalFulfillment = 'externalFulfillment',
}

export enum OfferSubtype {
  ProductDiscount = 'ProductDiscount',
  TransactionDiscount = 'TransactionDiscount',
  VarietyDiscount = 'VarietyDiscount',
  BOGO = 'BOGO',
  PromoCodes = 'PromoCodes',
  ProductPurchase = 'ProductPurchase',
  SpendBonus = 'SpendBonus',
  VisitChallenge = 'VisitChallenge',
  VarietyChallenge = 'VarietyChallenge',
  SweepstakeEntry = 'SweepstakeEntry',
  BaseEarn = 'BaseEarn',
  BaseEligibleEarn = 'BaseEligibleEarn',
  FuelRollback = 'FuelRollback',
  ExternalFulfillment = 'ExternalFulfillment',
}

// TODO Find better way to handle EMs without "award" field
// TODO: Implement EarningMechanismStoredValueDiscount
export type AwardType = Exclude<
  Exclude<
    EarningMechanism,
    EarningMechanismSpinWheelGame | EarningMechanismStoredValueDiscount
  >['award'],
  undefined | null
>;

export type OfferSchemaAward = AwardType['__typename'] | null;

export type OfferSchemaEarningMechanism = EarningMechanism['__typename'] | null;

export type OfferSchemaLimit = Limit['__typename'];

export type OfferSchemaConstraint = Constraint['__typename'];

export type OfferSchemaValidate = (offer: OfferFragment | PartialOfferFragment) => boolean;

export type OfferSchemaRequiredValues = Partial<
  Pick<OfferSchema, 'earningMechanism' | 'awards' | 'limits' | 'constraints'>
>;

export type OfferSchema = {
  type: OfferType;
  subtype?: OfferSubtype;
  engagementType: Offer_Engagement_Type;
  earningMechanism: OfferSchemaEarningMechanism[];
  awards: OfferSchemaAward[];
  limits: OfferSchemaLimit[];
  constraints: OfferSchemaConstraint[];
  requiredValues?: OfferSchemaRequiredValues;
  validate?: OfferSchemaValidate;
};

export type PartialOfferSchema = Pick<OfferSchema, 'type' | 'subtype'>;
